<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view/>
  </div>
</template>
<script>
	export default {
		created() {
			function isMobile(){
				if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
				  return true; 
				}else{
				  return false;
				}
			}
			//    判断后的操作
			if(isMobile()){
				location.href="http://h5.sgcmgd.cn/#/"
			}else{
				
			}
			
			
			this.$axios({
			        url:"/api"+"/site/menu/list",//请求的后台接口
			        method:"get",//get请求方式
					headers:{
						'User-Request-Type': 'riesun_site', 
						'siteid' : 'riesun_site_caa20f63ab704743b21741ba133e8499',
						'sitesecret' : '03569e80-00b6-4540-9e65-0a53f0f2ab7e',
					},
					params:{
						'siteType':1
					} //传给后台的参数
			    }).then(res=>{
					//头部菜单
					var imgs = res.data.data
					localStorage.setItem("imgs", JSON.stringify(imgs));
			　　//请求成功
			}).catch(error=>{
					console.log(error)
			});
		}
		
	}
	
</script>
<style>
	body::-webkit-scrollbar {
	display: none;
	}
</style>
<style lang="less">
*{
	margin: 0;
	padding: 0;
}
@font-face {
	font-family: 'wy';
	src: url('font/WenYue-GuDianMingChaoTi-JRFC-2.otf');
}
</style>
